import { useToastContext } from "@components/common/ui/Toast/Context";
import { Button } from "@kirvanobr/button";
import { Download01, Trash01 } from "@untitled-ui/icons-react";
import { Skeleton } from "@kirvanobr/skeleton";
import { Spacer } from "@kirvanobr/spacer";
import { Typography } from "@kirvanobr/typography";
import { useEffect, useState } from "react";

import ImageUploading, { ImageListType, ImageType } from "react-images-uploading";
import { styles } from "./Dropzone.styles";
import { DropzoneProps, DropzoneState, ImagePreviewProps } from "./Dropzone.types";

const ImagePreview = ({ previews }: ImagePreviewProps) => {
  const hasPreview = previews.length > 0;

  const renderPreviews = () =>
    previews.map((preview: string) => (
      <>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img key={preview} src={preview} className={styles().imagePreview()} alt="Logo" />
      </>
    ));

  return (
    <div className={styles().previewWrapper()}>
      {!hasPreview && (
        <Typography variant="subtitle" size="t4" className={styles().grayTextsMedium()}>
          Exemplo:
        </Typography>
      )}
      <div className={styles().previewBox({ hasPreview: hasPreview })}>{renderPreviews()}</div>
      {hasPreview && <Spacer y={4} />}
      {!hasPreview && (
        <Typography variant="subtitle" size="t4" className={styles().grayTextsCenter()}>
          234x60 horizontal
        </Typography>
      )}
    </div>
  );
};

export const DropzoneNew = ({
  defaultImageUrl,
  onFileUpload,
  multiple = false,
  isLoading,
  onRemoveFile,
}: DropzoneProps) => {
  const [state, setState] = useState<DropzoneState>({
    previews: [],
    files: null,
  });
  const [images, setImages] = useState<ImageType[]>([]);

  const toast = useToastContext();

  useEffect(() => {
    if (defaultImageUrl) {
      setState(prevState => ({
        ...prevState,
        previews: [...prevState.previews, defaultImageUrl],
      }));
    }
  }, [defaultImageUrl]);

  const handleRemove = async () => {
    if (onRemoveFile)
      await onRemoveFile()
        .then(() => {
          setState(prevState => ({
            ...prevState,
            files: null,
            base64: null,
            previews: [],
          }));
        })
        .catch(() => {});
  };

  const handleDownload = () => {
    const link = document.createElement("a");
    const fileExtensionRegex = /\.[^.]+$/;

    if (state.files) {
      const fileExtension = state.files[0].type.split("/")[1];
      link.href = (state.files && URL.createObjectURL(state.files[0])) || "";
      link.download = "logo." + fileExtension;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      return;
    }

    if (defaultImageUrl) {
      const fileExtension = defaultImageUrl?.match(fileExtensionRegex);
      link.href = defaultImageUrl || "";
      link.download = "logo" + fileExtension;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      return;
    }
  };

  const onChange = (imageList: ImageListType) => {
    // setImages(imageList as ImageType[]);
    // onFileUpload(imageList);
  };

  if (isLoading) return <Skeleton height={156} radius="xs" />;

  return (
    <ImageUploading value={images} onChange={onChange} maxFileSize={10000000} acceptType={["jpg", "jpeg", "png"]}>
      {({ imageList, onImageUpload, onImageRemoveAll, isDragging, dragProps, errors }) => (
        <>
          <div
            className={styles({ hasPreview: !!state.previews.length }).base()}
            onClick={!state.previews.length ? () => onFileUpload(images) : undefined}
            {...(!state.previews.length ? dragProps : {})}
          >
            <div className={styles().content()}>
              <div className={styles().uploadArea()}>
                {!state.previews.length && (
                  <div className={styles().contentWrapper()}>
                    <div>
                      <Typography size="t3" className={styles().grayTextsLight()}>
                        Solte o arquivo aqui ou{" "}
                        <Typography as="span" size="t3" weight="bold" className={styles().grayTextsBlue()}>
                          selecione do seu dispositivo
                        </Typography>
                      </Typography>
                      <Spacer y={2} />
                      <Typography size="t5" className={styles().grayTextsMedium()}>
                        Você pode inserir arquivo do tipo: PNG, JPG ou JPEG. <br />
                        Limite máximo de 1 MB.
                      </Typography>
                    </div>
                    <div className={styles().actionWrapper()}>
                      <ImagePreview previews={state.previews} />
                    </div>
                  </div>
                )}
              </div>

              {!!state.previews.length && (
                <div className={styles().actionWrapperWithImg()}>
                  <ImagePreview previews={state.previews} />
                  <div className={styles().actionGroup()}>
                    <Button
                      size="sm"
                      color="primary"
                      variant="outlined"
                      className={styles().actionButtons()}
                      startContent={<Download01 className={styles().actionIcons()} />}
                      onClick={handleDownload}
                      fullWidth
                    >
                      Download
                    </Button>
                    <Button
                      size="sm"
                      color="primary"
                      variant="outlined"
                      className={styles().actionButtons()}
                      startContent={<Trash01 className={styles().actionIcons()} />}
                      onClick={handleRemove}
                      fullWidth
                    >
                      Remover
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </ImageUploading>
  );
};
